import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { filter } from 'rxjs/operators';
import { IJournal } from './models/journal.model';
import { DatePipe } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { IFinanceConfig } from './models/finance-config.model';
import { ITransferFund } from './models/transfer-fund.model';
import { IBankTransaction } from './models/bank-transaction.model';
import { IDeposit } from './models/deposit.model';
import { IBankRegister } from './models/bank-register.model';
import { IReconcile } from './models/reconcile.model';
import { ICreditCardCharge } from './models/credit-card-charge.model';
import { IExpense } from './models/expense.model';
import { IReconcileCreditPayment, IgetReconcile } from './models/reconcile-credit-payment.model';
import { IBudget } from './models/budget.model';
import { IQuestionModel } from '../modules/shared/components/chatbot-modal/model/chatbot.model';
import { GelAllJournalRequestModel } from './models/journal-list.model';
import { InventoryJournalReport } from '../modules/shared/components/inventory-impacts-gl/models/inventoryGL.response.mode';
import { TimeZoneService } from '../modules/shared/services/timezone.service';
import { FinanceFilterNS } from './models/finance-filter.model';
import { HttpService } from '../modules/shared/services/http.service';

@Injectable({
    providedIn: 'root'
})
export class FinanceService {
    private userPermissionsBSubject: BehaviorSubject<any>;
    appUrl = "";
    localAppUrl = "";
    coreUrl = ""
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    constructor(
        private http: HttpClient,
        private datePipe: DatePipe,
        private timeZoneService: TimeZoneService,
        private httpService: HttpService,
    ) {
        this.appUrl = environment.apiUrl + "Cases/";
        this.coreUrl = environment.coreUrl;
        this.localAppUrl = environment.localApiUrl;
        this.userPermissionsBSubject = new BehaviorSubject<any>([]);

    }
    getLoggedUser(userId) {
        return this.http.get<any>(this.localAppUrl + 'users/' + userId)
            .toPromise()
            .then(res => res);
    }

    updateUser(user) {
        return this.http.put(this.localAppUrl + 'users/' + user.id, user, { headers: this.headers })
            .toPromise()
            .then(() => user);
    }

    getAllWarehouse(pageNo, pageSize, filters, searchValue, searchColumn, sortBy, isAscending) {
        let params = new HttpParams();
        params = (!pageNo ? params : params.append('PageNumber', pageNo))
        params = (!pageSize ? params : params.append('PageSize', pageSize))
        params = (!isAscending ? params : params.append('IsAscending', isAscending))
        params = (!sortBy ? params : params.append('SortBy', sortBy))
        params = (!searchColumn ? params : params.append('SearchColumns', searchColumn))
        params = (!searchValue ? params : params.append('SearchValue', searchValue))
        params = (!filters ? params : params.append('filter', filters))
        return this.http.get<any>(`${environment.inventoryURl}Warehouse`, { observe: 'response', params })
            .toPromise()
            .then(res => ({
                wareHouses: res.body,
                headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false});
            }))
    }

    addCase(c) {
        return this.http.post<any>(this.localAppUrl + 'allWarehouse/', c)
            .toPromise()
            .then(res => res);
    }

    getWarehouseById(caseId) {
        let url = this.localAppUrl + 'allWarehouse/' + caseId;
        return this.http.get<any>(url).toPromise().then(res => res);;
    }

    updateWarehouse(oneCase) {
        return this.http.put(this.localAppUrl + 'allWarehouse/' + oneCase.id, oneCase, { headers: this.headers })
            .toPromise()
            .then(() => oneCase);
    }

    deleteWarehouse(id) {
        return this.http.delete<any>(`${environment.inventoryURl}Warehouse/${id}`)
            .toPromise()
            .then(res => res);
    }

    checkClearBitData(email) {
        return this.http.get<any>(environment.clearBitAPIURL + email, {
            headers: new HttpHeaders({
                "Authorization": environment.clearBitAPIKey
            })
        })
            .toPromise()
            .then(res => res)
    }

    getAllStages() {
        return this.http.get<any>(this.localAppUrl + 'warehouseCategory')
            .toPromise()
            .then(res => res);
    }

    updateWarehouseStage(caseStage) {
        let url = this.localAppUrl + "warehouseCategory?id=" + caseStage.id + "&caseStageId=" + caseStage.caseStageId
        return this.http.put<any>(url, {
            headers: this.headers
        })
            .toPromise()
            .then(res => res);
    }

    getAllWarehouseStock(wareHouseId, pageNumber, pageSize, isAscending, sortBy, searchColumn, searchValue) {
        let params = new HttpParams();
        params = (!pageNumber ? params : params.append('pagenumber', pageNumber))
        params = (!pageSize ? params : params.append('pagesize', pageSize))
        params = (!isAscending ? params : params.append('isascending', isAscending))
        params = (!sortBy ? params : params.append('sortby', sortBy))
        params = (!wareHouseId ? params : params.append('id', wareHouseId))
        params = (!searchColumn ? params : params.append('searchcolumns', searchColumn))
        params = (!searchValue ? params : params.append('searchvalue', searchValue))

        return this.http.get<any>(`${environment.inventoryURl}Warehouse/WarehouseStockDetailsById`, { observe: 'response', params })
            .toPromise()
            .then(res => ({
                stockList: res.body,
                headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false});
            }))
    }

    getAllBin(wareHouseId, pageNumber, pageSize, isAscending, sortBy, searchColumn, searchValue, filter) {
        let params = new HttpParams();
        params = (!pageNumber ? params : params.append('PageNumber', pageNumber))
        params = (!pageSize ? params : params.append('PageSize', pageSize))
        params = (!isAscending ? params : params.append('IsAscending', isAscending))
        params = (!sortBy ? params : params.append('SortBy', sortBy))
        params = (!wareHouseId ? params : params.append('warehouseId', wareHouseId))
        params = (!searchColumn ? params : params.append('SearchColumns', searchColumn))
        params = (!searchValue ? params : params.append('SearchValue', searchValue))
        params = (!filter ? params : params.append('filter', filter))

        return this.http.get<any>(`${environment.inventoryURl}WarehouseBin`, { observe: 'response', params })
            .toPromise()
            .then(res => ({
                binList: res.body,
                headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false});
            }))
    }

    getAllContactSource(companyID: number) {
        return this.http.get<any>(this.coreUrl + 'Source/' + "?organizationId=" + companyID)
            .toPromise()
            .then(res => res);
    }

    getAllCategory() {
        return this.http.get<any>(this.localAppUrl + 'Category')
            .toPromise()
            .then(res => res);
    }

    getAllSubCategory() {
        return this.http.get<any>(this.localAppUrl + 'SubCategory')
            .toPromise()
            .then(res => res);
    }

    getAllPirority() {
        return this.http.get<any>(this.localAppUrl + 'Priority')
            .toPromise()
            .then(res => res);
    }

    getJournal(pageNo, pageSize, sortBy, isAscending, searchValue, searchColumns, fromDate, toDate) {
        return this.http.get<any>(environment.financeURl + "FinancialReport/Journal?"
            + "fromDate=" + "1/1/2020"
            + "&toDate=" + this.datePipe.transform(new Date(), "MM/dd/yyyy")
            + "&PageNumber=" + pageNo
            + "&PageSize=" + pageSize
            + "&SortBy=" + ""
            + "&IsAscending=" + isAscending
            + "&SearchValue=" + searchValue
            + "&SearchColumns=" + searchColumns
            ,
            { observe: 'response' })
            .toPromise()
            .then(res => ({
                inventory: res.body,
                headers: JSON.parse(res.headers.get('x-pagination'))
            }));
    }

    getJournalNew(pageNo, pageSize, sortBy, isAscending, searchValue, searchColumns, fromDate, toDate) {
        return this.http.get<any>(environment.financeURl + "FinancialReport/Journal?"
            + "fromDate=" + fromDate
            + "&toDate=" + toDate
            + "&PageNumber=" + pageNo
            + "&PageSize=" + pageSize
            + "&SortBy=" + ""
            + "&IsAscending=" + isAscending
            + "&SearchValue=" + searchValue
            + "&SearchColumns=" + searchColumns
            ,
            { observe: 'response' })
            .toPromise()
            .then(res => ({
                inventory: res.body,
                headers: JSON.parse(res.headers.get('x-pagination'))
            }));
    }

    getJournalWithFilter(data: GelAllJournalRequestModel) {
        return this.http.post<any>(environment.financeURl + "FinancialReport/Journal?",
            data,
            { observe: 'response' })
            .toPromise()
            .then(res => ({
                inventory: res.body,
                headers: JSON.parse(res.headers.get('x-pagination'))
            }));
    }

    financialTransactionDetail(fromDate, toDate, financialAccountId, pageNo, pageSize, sortBy, isAscending, searchValue, searchColumns, dateFilterType: string, isPagination: boolean, reportType: string) {
        return this.http.get<any>(environment.financeURl + "FinancialReport/FinancialTransactionDetail?"
            + "fromDate=" + fromDate
            + "&toDate=" + toDate
            + "&financialAccountId=" + financialAccountId
            + "&PageNumber=" + pageNo
            + "&PageSize=" + pageSize
            + "&SortBy=" + sortBy
            + "&IsAscending=" + isAscending
            + "&SearchValue=" + searchValue
            + "&SearchColumns=" + searchColumns
            + "&dateFilterType=" + dateFilterType
            + "&isPagination=" + isPagination
            + "&reportType=" + reportType
            ,
            { observe: 'response' })
            .toPromise()
            .then(res => ({
                inventory: res.body,
                headers: JSON.parse(res.headers.get('x-pagination'))
            }));
    }

    financialTransactionDetailPost(fromDate, toDate, financialAccountId, pageNo, pageSize, sortBy, isAscending, searchValue, searchColumns, dateFilterType: string, isPagination: boolean, reportType: string, includePreviousBalance: boolean = true,
        includeChildAccount: boolean = true, fiscalYearStartDate = null) {
        const data = { FromDate: fromDate, Todate: toDate, IncomeStatementStartDate: fiscalYearStartDate };
        return this.http.post<any>(environment.financeURl + "FinancialReport/FinancialTransactionDetail?"
            + "&financialAccountId=" + financialAccountId
            + "&PageNumber=" + pageNo
            + "&PageSize=" + pageSize
            + "&SortBy=" + sortBy
            + "&IsAscending=" + isAscending
            + "&SearchValue=" + searchValue
            + "&SearchColumns=" + searchColumns
            + "&dateFilterType=" + dateFilterType
            + "&isPagination=" + isPagination
            + "&includeChildAccount=" + includeChildAccount
            + "&includePreviousBalance=" + includePreviousBalance
            + "&reportType=" + reportType
            ,
            data,
            { observe: 'response' })
            .toPromise()
            .then(res => ({
                inventory: res.body,
                headers: JSON.parse(res.headers.get('x-pagination'))
            }));
    }

    financialTransactionDetailPostNew(data: FinanceFilterNS.TransactionDetailsFilterRequestModel) {
        return this.http.post<any>(environment.financeURl + "FinancialReport/FinancialTransactionDetailNew?",
            data,
            { observe: 'response' })
            .toPromise()
            .then(res => ({
                inventory: res.body,
                headers: JSON.parse(res.headers.get('x-pagination'))
            }));
    }

    getTransactionsGroupList(requestModel: FinanceFilterNS.GetAllTransactionGroupByRequest) {
        return this.httpService.create(`${environment.financeURl}FinancialReport/GetJournalGroupedPagedListNew`, requestModel);
    }


    manualJournalEntry(data: IJournal) {
        return this.http.post<any>(`${environment.financeURl}ManualJournalEntry`, data)
    }

    getVendorNames() {
        return this.http.get<any>(environment.inventorySalesOrderUrl + 'Vendor/VendorNames')
            .toPromise()
            .then(res => res);
    }

    getReferenceId(id: number) {
        return this.http.get<any>(`${environment.financeURl}AccountTransactionMaster/GetReference/${id}`);
    }

    getAllClasses(): Observable<any> {
        return this.http.get<any>(`${environment.financeURl}Class/ClassHierarchy`);
    }

    getAllClassesFlatList(): Observable<any> {
        return this.http.get<any>(`${environment.financeURl}Class/AllClass`);
    }

    getAccountTransactionMasterById(id): Observable<any> {
        return this.http.get<any>(`${environment.financeURl}AccountTransactionMaster/${id}`);
    }

    getFinanceConfiguration(name): Observable<any> {
        return this.http.get<any>(`${environment.configUrl}Configuration/ConfigurationsByModuleName?name=${name}`);
    }

    addConfiguration(obj: IFinanceConfig) {
        return this.http.post<any>(`${environment.configUrl}Configuration`, obj);
    }

    updateConfiguration(obj: IFinanceConfig) {
        return this.http.put<any>(`${environment.configUrl}Configuration`, obj);
    }

    getAllFinancialAccounts(showBalance: boolean = true) {
        return this.http.get<any>(`${environment.financeURl}FinancialAccount?accountType=0&showBalance=${showBalance}`);
    }

    getFundTransferDetails(id: number) {
        return this.http.get<any>(`${environment.financeURl}BankEntries/FundById?FundId=${id}`);
    }

    getAllBankRegisters(accId: number) {
        return this.http.get<any>(`${environment.financeURl}BankEntries/GetAllBankRegisters?bankAccountId=${accId}`);
    }

    getDepositById(id: number) {
        return this.http.get<any>(`${environment.financeURl}BankEntries/DepositById?depositId=${id}`);
    }

    getCheckDetailsById(id: number) {
        return this.http.get<any>(`${environment.financeURl}BankEntries/BankById?bankId=${id}`);
    }
    getCreditCardDetailsById(id: number) {
        return this.http.get<any>(`${environment.financeURl}BankEntries/CreditById?CreditId=${id}`);
    }
    getDepositDetailsById(id: number) {
        return this.http.get<any>(`${environment.financeURl}BankEntries/DepositById?depositId=${id}`);
    }
    getExpenseDetailsById(id: number) {
        return this.http.get<any>(`${environment.financeURl}BankEntries/ExpenseById?expenseId=${id}`);
    }
    getBankRegisterDetailsById(id: number) {
        return this.http.get<any>(`${environment.financeURl}AccountBankRegister/${id}`);
    }
    getBankRegisterDetails(id: number, accountsTransactionMasterID: number) {
        return this.http.get<any>(`${environment.financeURl}AccountBankRegister/${id}/${accountsTransactionMasterID}`);
    }

    bankEntriesVoidDelete(id: number, isVoid: boolean, transactionType: string, transactionTypeId: string) {
        return this.http.delete<any>(`${environment.financeURl}BankEntries/${transactionType}?${transactionTypeId}=${id}&isVoid=${isVoid}`);
    }
    bankRegisterVoidDelete(id: number, isVoid: boolean, transactionType: string, transactionTypeId: string, accTransactionMasterId: number) {
        return this.http.delete<any>(`${environment.financeURl}BankEntries/${transactionType}?${transactionTypeId}=${id}&isVoid=${isVoid}&accountTransactionMasterId=${accTransactionMasterId}`);
    }

    getEndingBalance(id) {
        return this.http.get<any>(`${environment.financeURl}AccountTransactionMaster/GetEndingBalance?financialAccountId=${id}`);
    }

    getBeginningBalance(id, date) {
        return this.http.get<any>(`${environment.financeURl}AccountTransactionMaster/GetBeginningBalance?financialAccountId=${id}&startDate=${date}`);
    }

    saveTransferFund(data: ITransferFund) {
        return this.http.post<any>(`${environment.financeURl}BankEntries/FundTransfer`, data);
    }

    saveBankEntries(data: IBankTransaction) {
        return this.http.post<any>(`${environment.financeURl}BankEntries`, data);
    }
    addOpeningBalance(id: number, amount: number) {
        return this.http.get<any>(`${environment.financeURl}FinancialAccount/AddOpeningBalance?financialAccountId=${id}&amount=${amount}`, {});
    }

    saveCreditCardCharges(data: ICreditCardCharge) {
        return this.http.post<any>(`${environment.financeURl}BankEntries/Credit`, data);
    }

    saveExpense(data: IExpense) {
        return this.http.post<any>(`${environment.financeURl}BankEntries/Expense`, data);
    }

    saveDeposit(data: IDeposit) {
        return this.http.post<any>(`${environment.financeURl}BankEntries/Deposit`, data);
    }

    saveBankRegister(data: IBankRegister) {
        return this.http.post<any>(`${environment.financeURl}AccountBankRegister`, data);
    }

    saveReconcile(data: IReconcile) {
        return this.http.post<any>(`${environment.financeURl}BankEntries/Reconcile`, data);
    }

    saveReconcileForCredit(data: IReconcileCreditPayment) {
        return this.http.post<any>(`${environment.financeURl}BankEntries/ReconcileForCredit`, data);
    }

    getReconcileBalance(data: IgetReconcile) {
        return this.http.get<any>(`${environment.financeURl}BankEntries/GetReconcileBeginningBalance?financialAccountId=${data.financialAccountId}&startDate=${data.startDate}&isBank=${data.isBank}`);
    }

    unDoLastReconcillation(isBankReconcile, id) {
        const reconcillation = isBankReconcile ? 'UndoBankReconcile?bankId' : 'UndoCreditReconcile?creditId'
        return this.http.delete<any>(`${environment.financeURl}BankEntries/${reconcillation}=${id}`)
    }

    getPaymentList() {
        return this.http.get<any>(`${environment.financeURl}BankEntries/GetPaymentList`);
    }

    reconcilePaymentList(id: number) {
        return this.http.get<any>(`${environment.financeURl}BankEntries/ReconcilePaymentList?bankAccountId=${id}`);
    }

    reconcileDepositList(id: number) {
        return this.http.get<any>(`${environment.financeURl}BankEntries/ReconcileDepositList?bankAccountId=${id}`);
    }

    reconcileDepositPaymentList(id: number) {
        return this.http.get<any>(`${environment.financeURl}BankEntries/ReconcileDepositPaymentList?bankAccountId=${id}`);
    }

    getCreditCardPaymentList(id: number) {
        return this.http.get<any>(`${environment.financeURl}BankEntries/ReconcileCreditPaymentList?creditAccountId=${id}&TransactionType=payment`);
    }

    getCreditCardDepositList(id: number) {
        return this.http.get<any>(`${environment.financeURl}BankEntries/ReconcileCreditPaymentList?creditAccountId=${id}&TransactionType=deposit`);
    }

    getCreditCardAllList(id: number) {
        return this.http.get<any>(`${environment.financeURl}BankEntries/ReconcileCreditPaymentList?creditAccountId=${id}&TransactionType=all`);
    }

    //#region General Ledger
    getGeneralLedger(reportType: string, pageNo: number, pageSize: number, sortBy: string, isAscending: boolean, searchValue: string, searchColumns: string, fromDate, toDate, dateFilterType) {
        return this.http.get<any>(environment.financeURl + "FinancialReport/GeneralLedger?"
            + "reportType=" + reportType
            + "&fromDate=" + fromDate
            + "&toDate=" + toDate
            + "&PageNumber=" + pageNo
            + "&PageSize=" + pageSize
            + "&SortBy=" + sortBy
            + "&IsAscending=" + isAscending
            + "&SearchValue=" + searchValue
            + "&SearchColumns=" + searchColumns
            + "&dateFilterType=" + dateFilterType
        );
    }
    getGeneralLedgerWithFilter(reportType: string, pageNo: number, pageSize: number, sortBy: string, isAscending: boolean, searchValue: string,
        searchColumns: string, fromDate, toDate, fromDateLocal, toDateLocal, dateFilterType, fiscalYearStartDate) {
        const data = { FromDate: fromDate, Todate: toDate, IncomeStatementStartDate: fiscalYearStartDate };
        return this.http.post<any>(environment.financeURl + "FinancialReport/GeneralLedger?"
            + "reportType=" + reportType
            + "&fromDateLocal=" + fromDateLocal
            + "&toDateLocal=" + toDateLocal
            + "&PageNumber=" + pageNo
            + "&PageSize=" + pageSize
            + "&SortBy=" + sortBy
            + "&IsAscending=" + isAscending
            + "&SearchValue=" + searchValue
            + "&SearchColumns=" + searchColumns
            + "&dateFilterType=" + dateFilterType,
            data,
        );
    }
    getGeneralLedgerById(reportType: string, pageNo: number, pageSize: number, sortBy: string, isAscending: boolean, searchValue: string, searchColumns: string, fromDate, toDate, financialAccId: number, dateFilterType: string) {
        return this.http.get<any>(environment.financeURl + "FinancialReport/GeneralLedgerDetail?"
            + "reportType=" + reportType
            + "&financialAccountId=" + financialAccId
            + "&fromDate=" + fromDate
            + "&toDate=" + toDate
            + "&PageNumber=" + pageNo
            + "&PageSize=" + pageSize
            + "&SortBy=" + sortBy
            + "&IsAscending=" + isAscending
            + "&dateFilterType=" + dateFilterType
            ,
            { observe: 'response' })
            .toPromise()
            .then(res => ({
                ledgers: res.body,
                headers: JSON.parse(res.headers.get('x-pagination'))
            }));
    }

    getInventoryJournalReport(selectedId: number, objectTypeId: number) {
        return this.http.get<InventoryJournalReport[]>(environment.financeURl + "FinancialReport/ImpactsOnGl?"
            + "transactionReferenceId=" + selectedId
            + "&entityTypeId=" + objectTypeId);
    }

    //#endregion

    //#region Trail Balance
    getTrailBalance(reportType: string, pageNo: number, pageSize: number, sortBy: string, isAscending: boolean, searchValue: string, searchColumns: string, fromDate, toDate, dateFilterType) {
        return this.http.get<any>(environment.financeURl + "FinancialReport/TrailBalance?"
            + "reportType=" + reportType
            + "&fromDate=" + fromDate
            + "&toDate=" + toDate
            + "&PageNumber=" + pageNo
            + "&PageSize=" + pageSize
            + "&SortBy=" + sortBy
            + "&IsAscending=" + isAscending
            + "&SearchValue=" + searchValue
            + "&SearchColumns=" + searchColumns
            + "&dateFilterType=" + dateFilterType
        );
    }

    getTrailBalanceWithFilter(reportType: string, pageNo: number, pageSize: number, sortBy: string, isAscending: boolean, searchValue: string, searchColumns: string,
        fromDate, toDate, fromDateLocal, toDateLocal, dateFilterType, fiscalYearStartDate) {
        const data = { FromDate: fromDate, Todate: toDate, IncomeStatementStartDate: fiscalYearStartDate };
        return this.http.post<any>(environment.financeURl + "FinancialReport/TrailBalance?"
            + "reportType=" + reportType
            + "&fromDateLocal=" + fromDateLocal
            + "&toDateLocal=" + toDateLocal
            + "&PageNumber=" + pageNo
            + "&PageSize=" + pageSize
            + "&SortBy=" + sortBy
            + "&IsAscending=" + isAscending
            + "&SearchValue=" + searchValue
            + "&SearchColumns=" + searchColumns
            + "&dateFilterType=" + dateFilterType,
            data
        );
    }
    getAdjustedTrailBalance(reportType: string, pageNo: number, pageSize: number, sortBy: string, isAscending: boolean, searchValue: string, searchColumns: string, fromDate, toDate, isAdjusted, dateFilterType) {
        return this.http.get<any>(environment.financeURl + "FinancialReport/TrailBalance?"
            + "reportType=" + reportType
            + "&fromDate=" + fromDate
            + "&toDate=" + toDate
            + "&PageNumber=" + pageNo
            + "&PageSize=" + pageSize
            + "&SortBy=" + sortBy
            + "&IsAscending=" + isAscending
            + "&SearchValue=" + searchValue
            + "&SearchColumns=" + searchColumns
            + "&isAdjusted=" + isAdjusted
            + "&dateFilterType=" + dateFilterType
        );
    }
    getAdjustedTrailBalanceWithFilter(reportType: string, pageNo: number, pageSize: number, sortBy: string, isAscending: boolean, searchValue: string, searchColumns: string,
        fromDate, toDate, fromDateLocal, toDateLocal, isAdjusted, dateFilterType) {
        const data = { FromDate: fromDate, Todate: toDate };
        return this.http.post<any>(environment.financeURl + "FinancialReport/TrailBalance?"
            + "reportType=" + reportType
            + "&fromDateLocal=" + fromDateLocal
            + "&toDateLocal=" + toDateLocal
            + "&PageNumber=" + pageNo
            + "&PageSize=" + pageSize
            + "&SortBy=" + sortBy
            + "&IsAscending=" + isAscending
            + "&SearchValue=" + searchValue
            + "&SearchColumns=" + searchColumns
            + "&isAdjusted=" + isAdjusted
            + "&dateFilterType=" + dateFilterType,
            data
        );
    }
    getTrailBalanceById(reportType: string, pageNo: number, pageSize: number, sortBy: string, isAscending: boolean, searchValue: string, searchColumns: string, fromDate, toDate, financialAccId: number, dateFilterType: string) {
        return this.http.get<any>(environment.financeURl + "FinancialReport/TrailBalanceDetail?"
            + "reportType=" + reportType
            + "&financialAccountId=" + financialAccId
            + "&fromDate=" + fromDate
            + "&toDate=" + toDate
            + "&PageNumber=" + pageNo
            + "&PageSize=" + pageSize
            + "&SortBy=" + sortBy
            + "&IsAscending=" + isAscending
            + "&dateFilterType=" + dateFilterType
            ,
            { observe: 'response' })
            .toPromise()
            .then(res => ({
                trials: res.body,
                headers: JSON.parse(res.headers.get('x-pagination'))
            }));
    }
    balanceSheetReport(reportType: string, fromDate, toDate, dateFilterType: string, displayColumn: string) {
        return this.http.get<any>(`${environment.financeURl}FinancialReport/BalanceSheetTree?reportType=${reportType}&fromDate=${fromDate}&toDate=${toDate}&dateFilterType=${dateFilterType}&displayColumn=${displayColumn}`);
    }

    // getBalanceSheetReportCustomizeTreeNode(reportType: string, fromDate, toDate, dateFilterType: string, displayColumn: string, compareWithQueryString: string) {
    //     let url = `${environment.financeURl}FinancialReport/BalanceSheetTreeNode?reportType=${reportType}&fromDate=${fromDate}&toDate=${toDate}&dateFilterType=${dateFilterType}&displayColumn=${displayColumn}`;
    //     if (compareWithQueryString && compareWithQueryString.length > 0) {
    //         url += `&${compareWithQueryString}`;
    //     }
    //     return this.http.get<any>(url);
    // }
    getBalanceSheetReportCustomizeTreeNodeComparer(reportType: string, fromDate, toDate, fiscalYearStartDate, dateFilterType: string, displayColumn: string, compareWithQueryString: string, filterWithQueryString: string) {
        let url = `${environment.financeURl}FinancialReport/BalanceSheetTreeNodeComparer?reportType=${reportType}&fromDate=${fromDate}&toDate=${toDate}&fiscalYearStartDate=${fiscalYearStartDate}&dateFilterType=${dateFilterType}&displayColumn=${displayColumn}`;
        if (compareWithQueryString && compareWithQueryString.length > 0) {
            url += `&${compareWithQueryString}`;
        }
        url += `&${filterWithQueryString}`;
        return this.http.get<any>(url);
    }
    getBalanceSheetReportCustomizeTreeNodeComparerPost(reportType: string, fromDate, toDate, fiscalYearStartDate, dateFilterType: string, displayColumn: string, compareWithQueryString: string, filterWithQueryString: string) {
        const data = { FromDate: fromDate, Todate: toDate, IncomeStatementStartDate: fiscalYearStartDate };
        let url = `${environment.financeURl}FinancialReport/BalanceSheetTreeNodeComparer?reportType=${reportType}&dateFilterType=${dateFilterType}&displayColumn=${displayColumn}`;
        if (compareWithQueryString && compareWithQueryString.length > 0) {
            url += `&${compareWithQueryString}`;
        }
        url += `&${filterWithQueryString}`;
        return this.http.post<any>(url, data);
    }

    // budget

    getBudgets(data) {
        return this.http.get<any>(environment.financeURl + "Budget/GetBudgetListing?"
            + "id=" + data?.id
            + "&PageNumber=" + data?.pageNo
            + "&PageSize=" + data?.pageSize
            + "&SortBy=" + data?.sortBy
            + "&IsAscending=" + data?.isAscending
            ,
            { observe: 'response' })
            .toPromise()
            .then(res => ({
                budgets: res.body,
                headers: JSON.parse(res.headers.get('x-pagination'))
            }));
    }
    getTypeByGroupId(groupId) {
        return this.http.get<any>(
            `${environment.financeURl}Type?groupId=${groupId}`
        );
    }
    saveBudget(data: IBudget) {
        return this.http.post<any>(`${environment.financeURl}Budget`, data);
    }

    editManualJournalEntry(data: IJournal) {
        return this.http.put<any>(`${environment.financeURl}ManualJournalEntry/EditManualJournalEntry`, data)
    }

    updateBankEntries(data: IBankTransaction) {
        return this.http.put<any>(`${environment.financeURl}BankEntries/EditBankTransaction`, data);
    }

    editExpense(data: IExpense) {
        return this.http.put<any>(`${environment.financeURl}BankEntries/EditExpenseTransaction`, data);
    }
    updateDeposit(data: IDeposit) {
        return this.http.put<any>(`${environment.financeURl}BankEntries/EditDeposit`, data);
    }
    updateCreditCardCharges(data: ICreditCardCharge) {
        return this.http.put<any>(`${environment.financeURl}BankEntries/EditCreditTransaction`, data);
    }

    updateBankRegister(data: IBankRegister) {
        return this.http.put<any>(`${environment.financeURl}AccountBankRegister`, data);
    }

    updateTransferFund(data: ITransferFund) {
        return this.http.put<any>(`${environment.financeURl}BankEntries/EditFundTransfer`, data);
    }

    //#region Finance ChatBot
    journalInitialize(fromDate, toDate, isDayLight: boolean, fiscalYearStartingMonth, fiscalYearEndingMonth) {
        const obj = {
            fromDate: fromDate,
            toDate: toDate,
            ianatimezone: this.timeZoneService.getUserIANATimeZone(),
            isDayLight: isDayLight,
            fiscalYearStartingMonth: fiscalYearStartingMonth,
            fiscalYearEndingMonth: fiscalYearEndingMonth,
        }
        return this.http.post<any>(`${environment.financeURl}FinanceBot/JournalInitialize`, obj);
    }
    journalAskQuestion(questionData: IQuestionModel) {
        return this.http.post<any>(`${environment.financeURl}FinanceBot/JournalProcess`, questionData);
    }
    //#endregion

    getPermissionData() {
        const data = this.userPermissionsBSubject.getValue();
        if (data.length) {
            return data;
        } else {
            const permissionData = localStorage.getItem('userPermissions') ? JSON.parse(localStorage.getItem('userPermissions')) : [];
            return permissionData;
        }
    }


    /** Reconciliation Report */

    fetchReconciliationReportStatement(id: number) {
        return this.http.get<any>(`${environment.financeURl}FinancialReport/ReconciliationReportStatement?financialAccountId=${id}`);
    }
    fetchReconciliationReport(financialAccountId: number, reconcileId: number) {
        return this.http.get<any>(`${environment.financeURl}FinancialReport/ReconciliationReport?financialAccountId=${financialAccountId}&reconcileId=${reconcileId}`);
    }

    /** End Reconciliation Report */

    fetchUserListByPagination(pageNumber: number, pageSize: number, searchValue: string) {
        return this.http.get(`${environment.appOrgUrl}User/PagedUserList?PageNo=${pageNumber}&PageSize=${pageSize}&search=${searchValue}`);
    }
    getUnlockedPostingPeriods() {
        return this.http.get(`${environment.financeURl}ClosingYear/UnlockedClosingYears`);
    }

}
